<mat-toolbar class="mat-elevation-z8">
  {{arrivalDepartureHeader}}
</mat-toolbar>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-dialog-content class="mt-2 overflow-auto">
  <table class="custom-table mb-3" mat-table [dataSource]="[arrivalDeparture]">

    <ng-container matColumnDef="departureCode">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.FLIGHT' | transloco }}</th>
      <td mat-cell *matCellDef="let departure"> {{ departure.departureCode }}</td>
    </ng-container>

    <ng-container matColumnDef="scheduledDeparture">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.DEPARTURE.SCHEDULED_DEPARTURE' | transloco }}
      </th>
      <td mat-cell *matCellDef="let departure"> {{ departure.scheduledDeparture | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="estimatedDeparture">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.DEPARTURE.ESTIMATED_DEPARTURE' | transloco }}
      </th>
      <td mat-cell *matCellDef="let departure"> {{ departure.estimatedDeparture | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="actualDeparture">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.DEPARTURE.ACTUAL_DEPARTURE' | transloco }}</th>
      <td mat-cell *matCellDef="let departure"> {{ departure.actualDeparture | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="arrivalStation">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.DEPARTURE.DESTINATION' | transloco }}</th>
      <td mat-cell *matCellDef="let departure"> {{ departure.arrivalStation }}</td>
    </ng-container>

    <ng-container matColumnDef="checkInStatus">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.DEPARTURE.CHECK_IN_STATUS' | transloco }}</th>
      <td mat-cell *matCellDef="let departure"> {{ departure.checkInStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="checkInDeskFrom">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.DEPARTURE.CHECK_IN_DESK_FROM' | transloco }}
      </th>
      <td mat-cell *matCellDef="let departure"> {{ departure.checkInDeskFrom }}</td>
    </ng-container>

    <ng-container matColumnDef="checkInDeskTo">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.DEPARTURE.CHECK_IN_DESK_TO' | transloco }}</th>
      <td mat-cell *matCellDef="let departure"> {{ departure.checkInDeskTo }}</td>
    </ng-container>

    <ng-container matColumnDef="stationName">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.STATION' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.stationName }} </td>
    </ng-container>

    <ng-container matColumnDef="terminalName">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.TERMINAL' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.terminalName }} </td>
    </ng-container>

    <ng-container matColumnDef="arrivalCode">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.FLIGHT' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.arrivalCode }}</td>
    </ng-container>

    <ng-container matColumnDef="operator">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.COMPANY' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.operator }}</td>
    </ng-container>

    <ng-container matColumnDef="gate">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.GATE' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.gate }}</td>
    </ng-container>

    <ng-container matColumnDef="scheduledArrival">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.SCHEDULED_ARRIVAL' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.scheduledArrival | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="estimatedArrival">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.ESTIMATED_ARRIVAL' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.estimatedArrival | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="actualArrival">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.ACTUAL_ARRIVAL' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.actualArrival | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="flightDepartureDate">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.FLIGHT_DEPARTED_DATE' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.flightDepartureDate | date: 'yyyy-MM-dd' }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.STATUS' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.status }}</td>
    </ng-container>

    <ng-container matColumnDef="orderShuttles">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ORDER_SHUTTLES' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.orderShuttles }}</td>
    </ng-container>

    <ng-container matColumnDef="remarks">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.INFO' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.remarks }}</td>
    </ng-container>

    <ng-container matColumnDef="departureStation">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.ARRIVING_FROM' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.departureStation }}</td>
    </ng-container>

    <ng-container matColumnDef="firstBagEstimated">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.FIRST_BAG_ESTIMATED' | transloco }}
      </th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.firstBagEstimated | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="firstBag">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.FIRST_BAG' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.firstBag | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="lastBag">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.LAST_BAG' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.lastBag | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="baggageClaimUnit">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.ARRIVAL.BAGGAGE_CLAIM' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival"> {{ arrival.baggageClaimUnit }}</td>
    </ng-container>

    <ng-container matColumnDef="updated">
      <th mat-header-cell *matHeaderCellDef>{{ 'FLIGHT.LAST_UPDATED' | transloco }}</th>
      <td mat-cell *matCellDef="let arrival">
        {{ arrival.updated | date: 'yyyy-MM-dd HH:mm' }}
        <!-- <mat-icon class="clickable" [matTooltip]="'FLIGHT.ZOOM_IN' | transloco">zoom_in</mat-icon> -->
      </td>
    </ng-container>

    <ng-container matColumnDef="empty-row">
      <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayFlightColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayFlightColumns">
    </tr>
  </table>

  <table class="custom-table" mat-table [dataSource]="orderShuttlesVM.length ? orderShuttlesVM : emptyData">
    <ng-container matColumnDef="orderNr">
      <th mat-header-cell *matHeaderCellDef> {{ 'ORDER_LIST.ORDER_NR' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.orderNr}} </td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.PERSONS' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.firstName}} {{ element.lastName }} </td>
    </ng-container>

    <ng-container matColumnDef="baggage">
      <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.BAGGAGE' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.baggage}} </td>
    </ng-container>

    <ng-container matColumnDef="childseats">
      <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.INFANTS' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.childseats}} </td>
    </ng-container>

    <ng-container matColumnDef="cars">
      <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.VEHICLES' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.cars}} </td>
    </ng-container>

    <ng-container matColumnDef="passengers">
      <th mat-header-cell *matHeaderCellDef> {{ 'SHUTTLE_PLANNING_PAGE.PERSONS' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.passengers}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> {{ 'ORDER_LIST.EMAIL' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <ng-container matColumnDef="cellular">
      <th mat-header-cell *matHeaderCellDef> {{ 'ORDER_LIST.PHONE' | transloco }} </th>
      <td mat-cell *matCellDef="let element"> {{element.cellular}} </td>
    </ng-container>

    <ng-container matColumnDef="empty-row">
      <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsOrders"></tr>
    <tr mat-row *matRowDef="let row; columns: orderShuttlesVM.length > 0 ? displayedColumnsOrders : ['empty-row'];"
    (click)="goToOrder(row.orderId)"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>STÄNG</button>
</mat-dialog-actions>
